var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

/**
 * Proposal field view
 */
Curriculog.ProposalForm.Field = (function ($, _, Backbone, Field) {

	Field = Curriculog.CurriculogView.extend({
		events: {
			'click': 'edit',
			'click .fieldset-buttons button[name="save"]': 'save',
			'keyup .fieldset-buttons button[name="save"]': 'saveKeyup',
			'click .fieldset-buttons button[name="cancel"]': 'cancel',
			'keyup .fieldset-buttons button[name="cancel"]': 'cancelKeyup',
			'change': 'onChange',
			'keypress': 'onKeypress',
			'keyup': 'onKeyup',
			'input': 'onInput' // IE10+ clear button
		},

		/**
		 * Init
		 *
		 * @param {Object}  options
		 * @param {Element} options.field - the field element
		 * @param {Model}   options.section - Section model
		 * @param {Model}   options.proposal - Proposal model
		 * @param {Object}  options.userPermissions -
		 */
		initialize: function (options) {
			Curriculog.CurriculogView.prototype.initialize.apply(this, arguments);
			this.section = options.section;
			this.proposal = options.proposal;
			this.userPermissions = options.userPermissions;
			this._unsaved_changes = false;

			this.mode = this.$el.data('mode');

			// call to getValue and allow overriding of the default model value for multi-valued fields
			this.model.set('value', this.getValue());

			this.listenTo(this.model, 'validated:invalid', this.onInvalid);
			this.listenTo(this.model, 'validated:valid', this.onValid);

			Backbone.Validation.bind(this);

			// We throttle the detectChanges function in the init so that
			// every field does not share the same throttle timeout.
			this.detectChanges = _.throttle(this.detectChanges, 600);
		},

		/**
		 * Renders a field
		 *
		 * @returns {promise}
		 */
		render: function () {
			this.setElement($('.field-' + this.model.id));
			this._unsaved_changes = false;
			return $.when();
		},

		/**
		 * Returns the actual field inside of the field view.
		 *
		 * @returns {Element} The input field.
		 */
		getInput: function() {
			return this.$el.find('.field-placeholder');
		},

		/**
		 * Switches a field into edit mode
		 *
		 * @param   {Event} [event]
		 * @returns {undefined}
		 */
		edit: function(event) {
			// var $target = $(event.currentTarget);
			var that = this,
				$field = this.$el,
				formView = app.formView; // Should this be passed down through the views?

			// if item is already editing, do not refetch
			if ($field.hasClass('active') || this.proposal.get('status') == 'unlaunched') {
				return;
			}

			this.stopEvent(event);

			// if user can't edit, don't switch view
			if (! this.userPermissions.canEdit) {
				return;
			}

			// if field is not editable, don't switch view
			if (! this.isEditable()){
				return;
			}

			// if field is a right half field that had a hidden sibling
			var hiddenFirstHalf = $field.attr('data-hidden-first-half');

			if (formView.trackingShown()) {
				formView.hideTracking().done(function() {
					formView.getField(that.model.id).edit();
				});
				return;
			}

			// Stash any error (import/launch errors) that are attached to the dom
			// already so we can restore the original error on cancel.
			this.model.validationErrorBeforeEdit = this.model.validationError;
			this.loadField('edit', hiddenFirstHalf);
		},

		/**
		 * Cancels edit mode, resets the fields value and places it in view mode
		 *
		 * @param   {Event} [event]
		 * @returns {promise}
		 */
		cancel: function(event) {
			var $field = this.$el;
			this.stopEvent(event);

			// Restore our stashed errors on cancel. These will override any errors
			// created when trying to save the field with invalid data while in edit
			// mode.
			this.model.validationError = this.model.validationErrorBeforeEdit;
			this.model.validationErrorBeforeEdit = null;

			// if field is a right half field that had a hidden sibling
			var hiddenFirstHalf = $field.attr('data-hidden-first-half');

			return this.loadField('view', hiddenFirstHalf);
		},
		cancelKeyup: function(event){
			if ( event.which === 13 ){
				this.cancel(event);
			}
		},
		/**
		 * Fetches the field from the server and renders it.
		 *
		 * @param   {String} mode - "edit" or "view"; Defaults to "view"
		 * @param   {Boolean} hiddenFirstHalf - if sibling to hidden field
		 * @returns {Promise}     - Resolved once the field is fully displayed
		 */
		loadField: function(mode, hiddenFirstHalf) {
			var that = this,
				$field = this.$el,
				defer = $.Deferred();

			mode = mode || 'view';

			this.addMask(this.$el, 'Loading Field');

			$.ajax({
				url: '/proposalField:' + this.model.id + '/getField',
				data: {
					mode: mode,
					canEdit: this.userPermissions.canEdit,
					status: this.proposal.get('status'),
					step: this.proposal.get('currentStepId'),
					user: this.proposal.get('user'),
					display: 'getField',
					hiddenFirstHalf: hiddenFirstHalf
				},
				success: function(data) {
					that.destroy();
					$field.replaceWith(data);
					that.mode = mode;

					var promises = [
						that.render(),
						that.expandHelp(),
						that.expandButtons(),
						that.reapplyErrors()
						];

					if (mode == 'edit') {
						promises.push(that.afterEdit());
					}


					$.when.apply($, promises).done(function(){
						that.removeMask(that.$el);
						that.$el.find('input').focus();
						Backbone.trigger('form:stretch');
						defer.resolve(data);
						Curriculog.Actions.log('proposal-field-loaded', mode);
					});

				}
			});

		return defer.promise();
		},

		/**
		 * Saves a field. Hopefully most of this can be moved to the model at some point.
		 *
		 * @param   {Event} [event]
		 * @returns {promise}
		 */
		save: function(event) {
			this.stopEvent(event);

			var that = this,
				$field = this.$el,
				defer = $.Deferred(),
				editList = this.model.get('editList');
				value = this.getValue();

			// validate input
			this.model.set({value: value}, {validate: true});

			if (this.model.validationError) {
				return defer.reject().promise();
			}

			this.addMask(this.$el, 'Saving Field');

			$.ajax({
				url: '/proposalField:' + that.model.id + '/save',
				type: 'PUT',
				data: {
					display: 'conflictDiff',
					proposalName: this.proposal.get('proposalName'),
					user: this.proposal.get('user'),
					field: this.model.id,
					value: value,
					editList: JSON.stringify(editList)
				},
				success: function(data) {
					// Conflict dialog removed due to bugs and time restraints id:9217
					// throw "(╯°□°)╯︵ ┻━┻";
					// If there is no conflict, data will be empty. Otherwise, data holds conflict info.
					// if (data) {
					// 	var conflict = that.showConflict(data);
					// 	// This conflict !== false part is a terrible hack to remove conflict dialogs for certain fields id:9214
					// 	if (conflict !== false){
					// 		conflict.then(defer.resolve, defer.reject);
					// 		return;
					// 	}
					// }

					var promises = [
						that.afterSave()
					];

					// that.model.set({value: value});
					$.when.apply($, promises).done(function() {
						// reset field to view mode

						// if field is a right half field that had a hidden sibling
						var hiddenFirstHalf = $field.attr('data-hidden-first-half');

						that.loadField('view', hiddenFirstHalf).done(
							defer.resolve,
							function(){
								Curriculog.Actions.log('proposal-field-saved');
							});

						if (that.model.get('title') > 0) {
							Backbone.trigger('change:title');
						}

						Backbone.trigger('change:activity');
					});


				}

			});
			return defer.promise();
		},

		saveKeyup: function(event){
			if ( event.which === 13 ){
				this.save(event);
			}
		},

		/**
		 * Handles processing and display of the field conflict dialog.
		 *
		 * @param   {String} data - The response data from the save field ajax call.
		 * @returns {Promise}     - Resolves on save, fails on cancel.
		 */
		showConflict: function(data) {
			var that = this,
				defer = $.Deferred(),
				editList = $(data).find('#conflictEditList').val().split(',');

			this.model.set({
				editList: editList
			});

			// Open the conflict resolution dialog
			var conflict = new Curriculog.ProposalForm.FieldConflict({
				yours: value,
				changed_data: data
			}).promise();

			// If the user cancels out of the conflict resolution dialog, we reject the promise
			conflict.fail(function() {
				that.removeMask(that.$el);
				defer.reject();
			});

			// The user has corrected the conflict (hopefully) and clicked save in the dialog
			conflict.done(function(corrected_value) {
				// Save the corrected value into the UI
				that.setValue(corrected_value);
				// ...and then to the server
				that.save().always(function() {
					// Reset the edit list so we dont overwrite any conflicts made while
					// correcting the conflict. (mindblown)
					that.model.set({editList: [0]});
				// Use the inner saves resolve/reject as our own.
				}).done(defer.resolve).fail(defer.reject);
			});

			return defer.promise();
		},

		/**
		 * Called before placing a field into edit mode.
		 *
		 * @interface
		 * @returns {Boolean} [description]
		 */
		isEditable: function() {
			// perform specific field type validation events
			// must always return either true or false
			return ! (Boolean(this.model.get('crosslistingDisabled')) || this.model.get('systemRequired') === 'sisID');
		},

		/**
		 * Called after placing a field into edit mode.
		 *
		 * @interface
		 * @returns {promise}
		 */
		afterEdit: function() {
			// Update the model value with the latest field value from the server.
			// This is also a workaround for textareas model value containing <br>s
			// that were converted from newlines for display. This created an issue
			// when comparing the model to the display value for change detection.
			// TODO: get a real api to fetch these models and display them via template.
			this.model.set('value', this.getValue());
			return $.when();
		},

		/**
		 * Called after successfully saving a field.
		 *
		 * @interface
		 * @returns {promise}
		 */
		afterSave: function() {
			this._unsaved_changes = false;
			if (this.model.get('conditional')) {
				// reload the steps list
				return proposalObject.ajaxTab('history');
			}
			return $.when();
		},

		/**
		 * Used to fetch the value of the field from the DOM for saving/etc.
		 *
		 * @interface
		 * @returns {*}
		 */
		getValue: function() {
			// return field specific value
			return null;
		},

		/**
		 * Used to set the value of the field in the DOM for canceling/etc.
		 *
		 * @interface
		 * @param   {*}         value
		 * @returns {undefined}
		 */
		setValue: function(value) {
			// set field specific value
			return;
		},

		/**
         * Used to return the display value of a field view
         *
		 * @interface
         * @returns {String}
         */
        getDisplayValue: function() {
            return this.getValue();
        },

		/**
		 * Called before switching modes to cleanup the view.
		 *
		 * @interface
		 * @returns {promise}
		 */
		destroy: function() {
			// Use of this promise is not currently implemented/needed, but it
			// may be required in the future near. To that end, any current/new
			// methods should always return a promise.
			// $.when() always returns a resolved promise;
			return $.when();
		},

		/**
		 * A hook into the backbone native `remove`. Removes this.el from the
		 * DOM and detatches all events attached via this.listenTo().
		 */
		remove: function() {
			this.destroy();
			return Curriculog.CurriculogView.prototype.remove.apply(this, arguments);
		},

		/**
		 * The model validation has failed, show the error.
		 *
		 * @param   {Model} model  This fields model
		 * @param   {Object} errors - Pairs of attributeName: errorMessage
		 */
		onInvalid: function(model, errors){
			this.model.validationError = errors;
			this.showError(model, errors.value);
		},

		/**
		 * Validation was a big success. Remove errors.
		 */
		onValid: function(model) {
			this.clearError({clear: true});
		},

		/**
		 * Generates and attachs errors to the field
		 *
		 * @param {object} model - UNUSED: The fields model
		 * @param {string} message - An error message
		 * @param {object} [options] - {
		 *		'class': 'error', // Override to add an element class
		 *		'clear': true // Setting to false will keep existing errors in place
		 *		}.
		 */
		showError: function(model, message, options) {
			var defaults = {
				'class': 'error',
				'clear': true
			};
			options = _.extend({}, defaults, options);

			this.clearError(options);

			var ele = this.generateErrorElement(model, message, options);
			this.placeError(ele, options);
			this.$el.addClass('invalid');

			Backbone.trigger('form:stretch');
		},

		/**
		 * Returns a DOM element representing a field error
		 *
		 * @param {object} model - The fields model
		 * @param {string} message - The error message to use as the body of the element
		 * @param {object} options - Use options.class to give the element a class
		 */
		generateErrorElement: function(model, message, options) {
			return $('<span>').addClass(options['class']).text(message);
		},

		/**
		 * Attaches a DOM element after the content of the field but before any buttons
		 *
		 * @param {object} error_ele - A DOM element that represents a field error
		 * @param {object} options - Not currently used but given anyway for overriding
		 */
		placeError: function(error_ele, options) {
			if (this.mode == 'edit' && this.proposal.get('status') != 'unlaunched') {
				this.$('.fieldset-buttons').before(error_ele);
			} else {
				this.$('.option-groups').append(error_ele);
			}
		},

		/**
		 * Clears any pre-existing errors from this field
		 *
		 * @param {object} options - Use options.clear = false to prevent clearing
		 */
		clearError: function(options) {
			this.$el.removeClass('invalid'); //for highlighting
			if (options.clear) {
				this.$('.error').remove();
			}
		},

		/**
		 * Used to show model errors after cancelling edit mode.
		 */
		reapplyErrors: function() {
			var error = this.model.validationError;
			if (error) {
				this.model.trigger('validated:invalid', this.model, error);
			}
		},

		/**
		 * Returns a boolean value representing if the field currently has
		 * unsaved changes.
		 *
		 * @returns {Boolean}
		 */
		hasUnsavedChanges: function() {
			return this._unsaved_changes;
		},

		/**
		 * A throttled function that updates the 'unsaved changes' cache. This
		 * function can be called as often as necessary without concern for
		 * computation overhead.
		 */
		detectChanges: function(){
			this._unsaved_changes = this.getValue() != this.model.get('value');

			// highlight the field if it has unsaved changes
			if (this._unsaved_changes) {
				this.$el.addClass('field-unsaved');
			} else {
				this.$el.removeClass('field-unsaved');
			}

		},

		/**
		 * Field event handler for value changes
		 *
		 * @param   {Event} event
		 */
		onChange: function(event) {
			this.detectChanges();
		},

		/**
		 * Field event handler for keypress
		 *
		 * @param   {Event} event
		 */
		onKeypress: function(event){
			/*noop*/
		},

		/**
		 * Field event handler for keyup
		 *
		 * @param   {Event} event
		 */
		onKeyup: function(event) {
			if ( event.which === 13 && this.mode !== 'edit' ){
				this.edit(event);
			} else if (this.mode === 'edit') {
				this.detectChanges();
			}
		},

		/**
		 * Field event handler for oninput. ONLY FOR IE 10+.
		 * Used to detect clearing the field via the X.
		 *
		 * @param   {Event} event
		 */
		onInput: function(event) {
			this.detectChanges();
		},

		/**
		 * Shows this fields help element
		 *
		 * @returns {promise}
		 */
		expandHelp: function() {
			if (this.proposal.get('showHelp')) {
				return this.$el.find('.help').show().promise();
			}
			return $.when();
		},

		/**
		 * Shows this fields Save and Cancel buttons
		 *
		 * @returns {promise}
		 */
		expandButtons: function() {
			if (this.mode != 'edit') {
				return $.when();
			}

			var buttons = this.$el.find('.fieldset-buttons');

			return $(buttons).slideDown({
				duration: 200,
				progress: function() {
					Backbone.trigger('form:stretch');
				}
			}).promise();
		}

	});

	return Field;

})($, _, Backbone, Curriculog.ProposalForm.Field || {});
